import { createFileRoute, redirect } from '@tanstack/react-router'

import i18n from '@/i18n'
import {
  AbsencesAllView,
  AbsencesView,
  abscencesAllFilterSchema
} from '@/modules/absences2'
import { semesterQueryOptions } from '@/queries/useSemesters'
import { getMetaWithPageTitle } from '@/utils/get-page-title'
import { isSelectedSemesterInOptions } from '@/utils/is-selected-semester-in-options'

export const Route = createFileRoute('/_auth/absences/all')({
  validateSearch: abscencesAllFilterSchema,
  component: () => (
    <AbsencesView>
      <AbsencesAllView />
    </AbsencesView>
  ),
  loaderDeps: ({ search }) => ({ search }),
  loader: async ({ deps: { search }, context }) => {
    const semesters = await context.queryClient.ensureQueryData(
      semesterQueryOptions({})
    )

    if (
      !search.semester ||
      !isSelectedSemesterInOptions(
        search.semester,
        semesters.semestersFromCurrentYearOptions
      )
    ) {
      throw redirect({
        replace: true,
        to: '/absences/all',
        search: {
          ...search,
          semester: semesters.currentSemester?.id
        }
      })
    }
  },
  head: () =>
    getMetaWithPageTitle([
      i18n.t('title.absences', { ns: 'absences2' }),
      i18n.t('title.all-absences', { ns: 'absences2' })
    ])
})
